module.exports = __webpack_public_path__ + "a5a551141ef703b872407beecbd8d437.jpg";